var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiCheckCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jfomqx0yya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.933a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-3.474-2.651a.656.656 0 0 0-.945.019L6.542 9.173 4.711 7.34a.656.656 0 0 0-.928.928L6.1 10.584a.657.657 0 0 0 .944-.017L10.536 6.2a.656.656 0 0 0-.009-.918z",
    fill: "#118936"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jfomqx0yya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .933)",
    d: "M0 0h14v14H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiCheckCircleFill);
export default __webpack_public_path__ + "static/media/bi_check-circle-fill.9a1cd09c8eac674f6333eccd0e9be6f6.svg";
export { ForwardRef as ReactComponent };